import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Serving the Lehigh Valley for Over 15 Years
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Fun Affairs is the Lehigh Valley's premier event entertainment rental company. Since our founding, we've been dedicated to making celebrations unforgettable with top-quality equipment and exceptional service.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Whether you're planning a birthday party, corporate event, school function, or community festival, we have everything you need. Our extensive inventory includes bounce houses, inflatable slides, interactive games, entertainment services, and much more.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We're proud to be a locally owned and operated business serving Allentown, Bethlehem, Easton, and surrounding Pennsylvania communities. Our team is committed to delivering reliable, on-time service with clean, safe, and well-maintained equipment for every event.
            </p>
            <Link 
              to="/about" 
              className="inline-block bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
            >
              Learn More About Us
            </Link>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://funaffairs.com/wp-content/uploads/2022/11/fun-affairs.png"
                alt="Fun Affairs - Event Entertainment Rentals"
                className="w-full h-auto"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-red-600 text-white p-8 rounded-2xl shadow-xl max-w-xs">
              <p className="text-4xl font-bold mb-2">5000+</p>
              <p className="text-base font-semibold">Successful Events</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}